// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_sg-5";
export var filledCircle = "_sg-4";
export var historyEntry = "_sg-3";
export var messageSideLeft = "_sg-1";
export var messageSideRight = "_sg-2";
export var orderTrackingCarouselWrapper = "_sg-6";
export var orderTrackingInfoContainer = "_sg-0";